import getExtensibilityState from '../store/getExtensibilityState';
import TaskPaneRunningInstance from '../store/schema/TaskPaneRunningInstance';
import TaskPaneType from '../store/schema/TaskPaneType';

export function getTaskPaneRunningInstance(type: TaskPaneType): TaskPaneRunningInstance {
    return getExtensibilityState().taskPanes.get(type);
}

export function getTaskPaneRunningInstanceByControlId(controlId: string): TaskPaneRunningInstance {
    return findTaskPane(taskPane => taskPane.controlId === controlId);
}

export function getTaskPaneType(controlId: string): TaskPaneType {
    const taskPaneTypes = [TaskPaneType.Persistent, TaskPaneType.NonPersistent];
    for (const type of taskPaneTypes) {
        const taskPane = getTaskPaneRunningInstance(type);
        if (taskPane && taskPane.controlId === controlId) {
            return type;
        }
    }
    return null;
}

function findTaskPane(
    predicate: (taskPane: TaskPaneRunningInstance) => boolean
): TaskPaneRunningInstance {
    const state = getExtensibilityState();
    for (const taskPane of state.taskPanes.values()) {
        if (predicate(taskPane)) {
            return taskPane;
        }
    }

    return null;
}

export function getConverseTaskPaneType(type: TaskPaneType): TaskPaneType {
    return type === TaskPaneType.Persistent ? TaskPaneType.NonPersistent : TaskPaneType.Persistent;
}
